import { useOutlet } from "react-router-dom";
import { Box, OverlayScrollbarWrapper } from "../../common/components";
import AdminToolbar from "./AdminToolbar";
import { ROUTES } from "../../constant/common.constant";
import { palette } from "../../styles/theme";
import { usePathActive } from "../../common/hooks/usePathActive";
import { useEffect, useRef, useState } from "react";
import AdminProvider from "../../context/Admin/AdminProvider";

const Admin = () => {
  const outlet = useOutlet();
  const hiddenRoutes = [
    ROUTES.ADMIN_ALL_ORDERS,
    ROUTES.ADMIN_STUDIO_PURCHASED_DESIGN,
    ROUTES.ADMIN_DISTRIBUTORS,
    ROUTES.ADMIN_USERS,
  ];
  const { checkActive } = usePathActive();
  const isHiddenRoute = hiddenRoutes.some((route) => checkActive(route));
  const [isToolbarVisible, setIsToolbarVisible] = useState(true);
  const lastScrollTop = useRef(0);

  const hideDownloadButton =
    checkActive(ROUTES.ADMIN_ALL_ORDERS) || checkActive(ROUTES.ADMIN_ORDER);

  const handleScroll = (event: Event) => {
    const target = event.target as HTMLElement;
    const currentScrollTop = target.scrollTop;

    if (currentScrollTop > lastScrollTop.current && currentScrollTop > 86) {
      setIsToolbarVisible(false);
    } else {
      setIsToolbarVisible(true);
    }
    lastScrollTop.current = currentScrollTop <= 0 ? 0 : currentScrollTop;
  };

  useEffect(() => {
    const scrollContainer = document.getElementById("admin-container");
    const scrollableViewport = scrollContainer?.querySelector(
      "[data-overlayscrollbars-contents]"
    );

    if (scrollableViewport) {
      scrollableViewport.addEventListener("scroll", handleScroll);
      return () => {
        scrollableViewport.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  if (isHiddenRoute) {
    return outlet;
  }

  return (
    <AdminProvider>
      <Box
        sx={{
          width: "100%",
          backgroundColor: palette.grey.lightBackground,
        }}
      >
        <OverlayScrollbarWrapper
          id="admin-container"
          style={{ maxHeight: "100dvh", minHeight: "0", height: "100dvh" }}
        >
          <Box display="flex" flexDirection="column" gap={"18px"}>
            <AdminToolbar
              isVisible={isToolbarVisible}
              hideDownloadButton={hideDownloadButton}
            />
            <Box
              sx={{
                flex: 1,
                pt: "86px",
                pl: "24px",
                pb: "48px",
                "@media print": {
                  pt: 0,
                  pl: 0,
                  pb: 0,
                },
              }}
            >
              {outlet}
            </Box>
          </Box>
        </OverlayScrollbarWrapper>
      </Box>
    </AdminProvider>
  );
};

export default Admin;
